const systems = {
    administrative: "אדמין",
    school: "בית ספר"
}

export default systems